import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import styles from './_mid2018Header.css'

function Header (props) {
  const { showSponsor } = props
  return (
    <div className={styles.header}>
      <h1 className={styles.headerTitle}>
        <FormattedMessage
          id='midyear.2018.header.title'
          defaultMessage={`Your 2018 Mid-Year\nProgress Report`}
        />
      </h1>
      { showSponsor ?
        <div className={styles.headerByline}>
          <FormattedHTMLMessage
            id='midyear.2018.sponsor'
            defaultMessage='<span>Sponsored By</span> <svg height="50" width="200"><use xlink:href="#afi-logo" /></svg>'
            />
        </div>
      : null }
    </div>
  )
}

Header.propTypes = {
  showSponsor: PropTypes.bool,
}

export default Header



// WEBPACK FOOTER //
// ./src/components/yearInReview/2018/midyear/Header/index.js